
<template>
  <!--新增应用-->
  <x-addEdit
    ref="addEdit"
    @updateReqData="reqData=$event"
    :formList="formList"
    :formKey="formKey"
    :formData="formData"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="transfer" slot-scope="{formItem}">
      <a-form-item :label="formItem.label" required v-bind="$store.state.base_itemLayout">
        <transfer ref="transfer"/>
      </a-form-item>
    </template>
  </x-addEdit>
</template>

<script>
import { fetchSelect, userRange } from '@/utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
import transfer from '../../views/transfer.vue';
export default {
  mixins: [fetchSelect, addEdit, userRange],
  name: 'addApplication',
  components: {
    transfer
  },
  data () {
    let decoratorOptions = {
      title: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入应用名称'},
          {min: 2, max: 20, message: '功能名为2-20个字'}
        ]
      },
      uniqueMark: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入功能识别符'},
          {min: 2, max: 20, message: '功能识别符为2-20个字'}
        ]
      },
      icon: {
        rules: [{required: true, message: '请上传图标'}]
      },
      platform: {
        rules: [{required: true, message: '请选择平台'}]
      },
      sort: {rules: []},
      isDefault: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{required: true, message: '请选择是否默认'}]
      },
      price: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '请输入价格'}]
      },
      scopeType: {
        rules: [{required: true, message: '请选择应用范围'}]
      },
      description: {rules: [{min: 2, max: 20, message: '描述信息为2-20个字'}]}
    };
    return {
      reqData: '',
      appTypeObj: {
        addCommunityApp: { appType: 2 },
        addStewardApp: { appType: 1 }
      },
      formData: '',
      formKey: {
        title: '',
        uniqueMark: '',
        icon: '',
        platform: '',
        sort: '',
        isDefault: '',
        price: '',
        scopeType: '',
        android: '',
        ios: '',
        scope: '',
        cityScope: '',
        communityScope: '',
        description: ''
      },
      formList: [
        {
          label: '应用名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入应用名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '识别符',
          inputType: 'input',
          options: [],
          placeholder: '请输入识别符',
          props: ['uniqueMark', decoratorOptions.uniqueMark]
        },
        {
          label: '图标',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'iconUrl', // 详情返回图片的链接
            iconName: 'iconUrl', // 详情返回文件的名

            action: this.$store.state.uploadUrl,
            accept: this.$store.state.imgAccept,
            listType: 'picture',
            uploadType: 4
          },
          props: ['icon', decoratorOptions.icon]
        },
        {
          label: '平台',
          inputType: 'checkboxGroup',
          options: [],
          placeholder: '',
          props: ['platform', decoratorOptions.platform]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序',
          type: 'number',
          extra: '默认排序：99',
          props: ['sort', decoratorOptions.sort]
        },
        {
          label: '是否默认',
          inputType: 'switch',
          options: [],
          placeholder: '请选择是否默认',
          props: ['isDefault', decoratorOptions.isDefault]
        },
        {
          label: '价格',
          inputType: 'input',
          options: [],
          placeholder: '请输入价格',
          props: ['price', decoratorOptions.price]
        },
        {
          label: '应用范围',
          inputType: 'select',
          options: this.$store.state.userRange,
          handle: e => this.handleUserRange(e),
          placeholder: '请选择应用范围',
          props: ['scopeType', decoratorOptions.scopeType]
        },
        {
          isShow: false,
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: true,
          key: 'city',
          props: ['cityScope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          slot: 'transfer',
          isShow: false,
          label: '选择小区',
          inputType: 'text',
          options: [],
          placeholder: '',
          titles: ['小区列表', '已选'],
          key: 'community',
          props: ['communityScope', {
            rules: [{required: true, message: '请选择小区'}]
          }]
        },
        {
          label: '应用描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['description', decoratorOptions.description]
        }
      ],
      addParam: {
        url: '/application',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/application/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/application/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      let paramArr = [
        {index: 3, scope: 'formList', query: 'comu_application_platform'}
        // {index: 7, scope: 'formList', query: 'comu_application_scope_type'}
      ];
      this.formList[7].options = [
        {label: '全部用户', value: 0},
        {label: '指定城市', value: 1},
        {label: '指定小区', value: 2}
      ];
      this.dictionarySelect(paramArr);
      this.userRangeList(8, 9);
    },
    /* 处理用户范围 */
    handleUserRange (val, formVals) {
      let userTypeObj = {
        0: { city: false, community: false },
        1: { city: true, community: false },
        2: { city: false, community: true }
      };
      this.handleDynamicForm(val, userTypeObj);
      formVals && (this.formData = formVals);

      if (formVals) {
        this.$nextTick(() => {
          if (formVals.scopeType === 2) {
            this.$refs.addEdit.targetKeys = formVals.scope;
          }
          this.$refs.addEdit.form.setFieldsValue(formVals);
        });
      }
    },
    reqHandle (param) {
      let arealist = this.$refs.transfer && this.$refs.transfer.targetKeys;
      param = {...param, ...this.appTypeObj[this.$route.name]};
      param.isDefault = param.isDefault === true ? 1 : 0;

      let platform = param.platform;
      if (platform.length) {
        platform.forEach((el) => {
          el === '1' && (param.ios = '1');
          el === '2' && (param.android = '1');
        });
        if (!param.hasOwnProperty('ios')) {
          param.ios = '0';
        }
        if (!param.hasOwnProperty('android')) {
          param.android = '0';
        }
      } else {
        param.android = '0';
        param.ios = '0';
      }
      if (param.scopeType == 2 && arealist.length == 0) {
        this.$message.error('请选择小区');
        return;
      }
      if (param.scopeType == 2 && arealist.length != 0) {
        param.communityScope = arealist;
      }
      param.platform = param.platform.join(',');
      if (param.cityScope) {
        param.scope = param.cityScope = param.cityScope.join(',');
      }
      if (param.communityScope) {
        param.scope = param.communityScope = param.communityScope.join(',');
      }
      param = this.rangeReqVal(param);
      return param;
    },
    detailResHandle (res) {
      if (res.scopeType == 2) {
        setTimeout(() => {
          this.$refs.transfer.setTarget(res.scope.split(','));
        }, 0);
      }

      let value = {};
      for (let item in res) {
        if (this.formKey.hasOwnProperty(item)) {
          value[item] = res[item];
        }
      }
      res.isDefault === 1 ? value.isDefault = true : value.isDefault = false;
      let arr = [];
      (res.android === '1') && arr.push('2'); // ios: 1, android: 2
      (res.ios === '1') && arr.push('1');
      value.platform = arr;
      if (res.scope) {
        value.scope = res.scope.split(',');
        value = this.rangeResVal(value, res);
      }
      this.handleUserRange(res.scopeType, value);
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
